<template>
  <div class="main2-content">
    <div class="panel-content">
      <div class="layout-flex">
        <div class="menu" v-for="(item, index) in menu" :key="index" :style="{
          background: index == btnIndex ? item.color : '',
          color: index == btnIndex ? '#fff' : '',
        }" @click="handleMenu(index)">
          <div><img class="img" :src="index == btnIndex ? item.be : item.to" /></div>
          <div class="name">{{ item.name }}</div>
          <div class="nameEn">{{ item.nameEn }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "./config1";
export default {
  components: {},
  data() {
    return {
      ...config,
      btnIndex: 0,
      activeNames: 0,
      activeNames1: 0,
      activeNames2: 0,
      activeNames3: 0,
      menu: [
        {
          name: "臻品卓越",
          nameEn: "Exceptional Quality",
          to: require("../../assets/image/esg/imgsMobile/icon1-1.png"),
          be: require("../../assets/image/esg/imgsMobile/icon1-2.png"),
          color: "#C39A6B",
        },
        {
          name: "气候变化",
          nameEn: "Climate Change",
          to: require("../../assets/image/esg/imgsMobile/icon2-1.png"),
          be: require("../../assets/image/esg/imgsMobile/icon2-2.png"),
          color: "#12A79D",
        },
        {
          name: "守护生态环境",
          nameEn: "Protecting the Ecological Environment",
          to: require("../../assets/image/esg/imgsMobile/icon3-1.png"),
          be: require("../../assets/image/esg/imgsMobile/icon3-2.png"),
          color: "#12A79D",
        },
        {
          name: "共筑和谐社会",
          nameEn: "Contribute to a Harmonious Society",
          to: require("../../assets/image/esg/imgsMobile/icon4-1.png"),
          be: require("../../assets/image/esg/imgsMobile/icon4-2.png"),
          color: "#C39A6B",
        },
        {
          name: "稳健公司治理",
          nameEn: "Robust Corporate Governance",
          to: require("../../assets/image/esg/imgsMobile/icon5-1.png"),
          be: require("../../assets/image/esg/imgsMobile/icon5-2.png"),
          color: "#144E82",
        },
      ],
      scene1: 0,
      scene2: 0,
      scene3: 0,
      scene4: 0,
      scene5: 0,
      scene6: 0,
    };
  },
  computed: {},
  beforeMount() { },
  mounted() { },
  methods: {
    layoutShow(val = 0) {
      if (val == this.btnIndex) {
        return true;
      } else {
        return false;
      }
    },
    handleMenu(index) {
      this.btnIndex = index;
      this.$parent.btnIndex = index;
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./commonMobile.less");

.layout-flex {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 7px;
  margin-top: 30px;
  margin-bottom: 24px;
}

.menu {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 72px;
  background: #E5E9E8;
  color: #747474;
  text-align: center;
  font-size: 9px;

  .img {
    width: 24px;
    height: 24px;
    margin-top: 8px;
  }

  .name {
    margin-top: 3px;
  }
}
</style>
